export const gridOptions = {
  rowSelection: {
    mode: "multiRow",
    checkboxes: {
      visible: true,
      position: "start",
      width: 50,
    },
    enableClickSelection: true,
  },
  getRowClass: (params) => {
    return params.node.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd";
  },
};